module.exports = __webpack_public_path__ + "static/onsite-e5d895b15de396a9ecd0cd0feb9ad576.jpg";